/**
 * Shared utilities for the Karel app.
 *
 * This is a trimmed, ES-module port of the legacy `site/lib/util.js`. Only the
 * helpers still used by the application are kept; the Java-simulation helpers
 * (Integer/Double/Character) and the synchronous XHR loader were removed.
 */

/** Converts a camelCase identifier to snake_case (`turnRight` -> `turn_right`). */
export function camelToSnake(name: string): string {
  return name
    .replace(/([a-z0-9])([A-Z])/g, "$1_$2")
    .replace(/([A-Z]+)([A-Z][a-z])/g, "$1_$2")
    .toLowerCase();
}

export function deepCopyUtil<T>(p: T, c?: unknown): T {
  if (p == null) return p;
  const target: Record<string, unknown> =
    (c as Record<string, unknown>) || ({} as Record<string, unknown>);
  for (const i in p as Record<string, unknown>) {
    const value = (p as Record<string, unknown>)[i];
    if (typeof value === "object" && value != null) {
      target[i] = value.constructor === Array ? [] : {};
      deepCopyUtil(value, target[i]);
    } else {
      target[i] = value;
    }
  }
  return target as T;
}

export class AssertException extends Error {
  constructor(message: string) {
    super(message);
    this.name = "AssertException";
  }
}

export function assert(exp: unknown, message?: string): asserts exp {
  if (!exp) {
    throw new AssertException(message ?? "Assertion failed");
  }
}
